<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('select_delivery') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-list subheader class="__shipping-method">
          <v-list-item v-if="!checkEnabled" @click="goTo({}, 1)">
            <v-list-item-avatar class="icon-delivery_method">
              <v-img src="@/assets/images/svg/free_ongkir.svg" max-height="30" max-width="30" contain />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold" v-html="$t('free_shipping_limited')" />
              <template v-if="!$isEmpty(selected_outlet) && totalPriceItem < Number(selected_outlet.delivery.minimum_order)">
                <v-list-item-subtitle v-if="dataCheckoutDelivery.shipping_radius > $store.state.selected_outlet.delivery.radius_free_delivery">
                  <div
                    v-html="$t('minimum_order_distance_message', {
                      minimumOrder: $maskMoney(selected_outlet.delivery.minimum_order),
                      distanceExceeded: dataCheckoutDelivery.shipping_radius - $store.state.selected_outlet.delivery.radius_free_delivery,
                      shippingFee: $maskMoney(dataCheckoutDelivery.shipping_radius * $store.state.selected_outlet.delivery.cost_outside_radius)
                    })"
                  />
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else>
                  <div
                    v-html="$t('minimum_order_message', {
                      minimumOrder: $maskMoney(selected_outlet.delivery.minimum_order),
                      deliveryFee: $maskMoney(dataCheckoutDelivery.shipping_radius * $store.state.selected_outlet.delivery.cost_outside_radius)
                    })"
                  />
                </v-list-item-subtitle>
              </template>
              <template v-else>
                <v-list-item-subtitle v-if="dataCheckoutDelivery.shipping_radius > $store.state.selected_outlet.delivery.radius_free_delivery">
                  <div
                    v-html="$t('distance_summary', {
                      distance: dataCheckoutDelivery.shipping_radius,
                      excess: dataCheckoutDelivery.shipping_radius - $store.state.selected_outlet.delivery.radius_free_delivery,
                      fee: $maskMoney((dataCheckoutDelivery.shipping_radius - $store.state.selected_outlet.delivery.radius_free_delivery) * $store.state.selected_outlet.delivery.cost_outside_radius)
                    })"
                  />
                </v-list-item-subtitle>
              </template>
            </v-list-item-content>
          </v-list-item>
          <!-- {{ list_shipping }} -->
          <!-- <template v-for="(item, idx) in list_shipping">
            <div v-if="item.detail.length > 0 && item.estimate_range > 0" :key="idx + ' subheader'" class="font-weight-bold shipping-subheader">
              {{ item.type }}
            </div>
            <template v-if="item.detail.length > 0 && item.estimate_range > 0">
              <v-list-item v-for="(detail, x) in item.detail" :key="x" :disabled="!detail.active" @click="goTo(item.detail[x], 2)">
                <v-list-item-avatar class="icon-delivery_method">
                  <v-img :src="detail.logo" max-height="30" max-width="30" contain class="br-4" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold" v-html="detail.name" />
                  <v-list-item-subtitle v-html="detail.shipment_method_description" />
                </v-list-item-content>
                <v-list-item-action v-if="detail.price > 0">
                  <div class="d-flex align-center">
                    <div class="estimate-text mr-1">
                      <span v-mask-money="detail.price" />
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </template>
          </template> -->

          <template v-for="(item, idx) in list_shipping">
            <div v-if="list_shipping.length > 0" :key="idx + ' subheader'" class="font-weight-bold shipping-subheader">
              {{ item.type }}
            </div>
            <v-list-item v-if="list_shipping.length > 0" :key="idx + ' list'" :disabled="timeShipper(item).disabled && timeShipper(item).limited_time" @click="goTo(item, 2)">
              <v-list-item-avatar class="icon-delivery_method">
                <v-img :src="item.image_url" max-height="30" max-width="30" contain class="br-4" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold" v-html="item.logistic_name " />
                <v-list-item-subtitle v-if="timeShipper(item).limited_time" :class="[{ 'warning--text': timeShipper(item).end_soon }]" v-html="timeShipper(item).text" />
              </v-list-item-content>
              <v-list-item-action v-if="item.final_price > 0">
                <div class="d-flex align-center">
                  <div class="estimate-text mr-1">
                    <span v-mask-money="item.final_price" />
                  </div>
                </div>
              </v-list-item-action>
            </v-list-item>
          </template>
          <!-- <v-list-item disabled @click="goTo()">
            <v-list-item-avatar class="icon-delivery_method">
              <v-img src="@/assets/images/grab_express_icon.png" max-height="30" max-width="30" contain />
            </v-list-item-avatar>
            <span class="tag__coming-soon">
              Coming soon
            </span>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold" v-html="'Grab Express'" />
              <v-list-item-subtitle v-html="'Biaya mengikuti standard Grab yang berlaku.'" />
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  getDataShippingV2
} from '@/api/order'
export default {
  data() {
    return {
      dataCheckoutDelivery: {
        shipping_address: '',
        shipping_delivery_type: 1,
        shipping_time: '',
        shipping_radius: 0,
        shipping_cost: 0,
        item: [],
        shipping_courier_id: '',
        shipping_courier_name: ''
      },
      list_shipping: [],
      selected_outlet: {},
      item_price: [],
      totalPriceItem: 0
    }
  },
  computed: {
    checkEnabled() {
      if (!this.$isEmpty(this.selected_outlet)) {
        if (!this.selected_outlet.delivery.turn_off_private_courier) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))) this.dataCheckoutDelivery = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))
    if (this.$store.state.selected_outlet && !this.$isEmpty(this.$store.state.selected_outlet)) {
      this.selected_outlet = this.$store.state.selected_outlet
    }
    this.getListShipping()
    this.getTotalPrice()
  },
  methods: {
    timeShipper(item) {
      const obj = {
        limited_time: false,
        end_soon: false,
        disabled: false,
        text: ''
      }
      if (!this.$isEmpty(item.time_oprational) && item.time_oprational.open_time !== '' && item.time_oprational.close_time !== '') {
        obj.limited_time = true
        obj.text = this.$t('available_time', { time: item.time_oprational.open_time + ' - ' + item.time_oprational.close_time })
      }

      const today = new Date()
      const hours = today.getHours()
      const minutes = today.getMinutes()
      const arrCloseTime = typeof item.time_oprational.close_time !== 'undefined' ? item.time_oprational.close_time.split(':') : []
      if (hours >= Number(arrCloseTime[0])) {
        obj.end_soon = true
        obj.text = this.$t('end_soon', { time: (arrCloseTime[1] - minutes) })
      }
      if (hours >= (Number(arrCloseTime[0]) + 1)) {
        obj.disabled = true
        obj.text = ''
      } else if (hours === Number(arrCloseTime[0]) && minutes > Number(arrCloseTime[1])) {
        obj.disabled = true
        obj.text = ''
      }
      return obj
    },
    getTotalPrice() {
      if (this.dataCheckoutDelivery.item) {
        for (const i in this.dataCheckoutDelivery.item) {
          this.item_price[i] = this.dataCheckoutDelivery.item[i].sub_total
        }
      }
      this.sumPrice(this.item_price)
    },
    sumPrice(obj) {
      var sum = 0
      for (var el in obj) {
        if (obj.hasOwnProperty(el)) {
          sum += parseFloat(obj[el])
        }
      }
      this.totalPriceItem = sum
    },
    goBack() {
      this.$router.push({ name: 'delivery_menu' }).catch(() => {})
    },
    goTo(item = {}, id = 1) {
      this.dataCheckoutDelivery.shipping_delivery_type = id
      if (id === 2) {
        this.dataCheckoutDelivery.shipping_cost = item.final_price
        this.dataCheckoutDelivery.shipping_courier_id = item.rate_id
        this.dataCheckoutDelivery.shipping_courier_name = item.logistic_name
        delete this.dataCheckoutDelivery.shipping_time
        this.$router.push({ name: 'checkout' }).catch(() => {})
      } else if (id === 1) {
        const LOCAL_DATA_selected_outlet = this.$store.state.selected_outlet
        if (this.dataCheckoutDelivery.shipping_radius > LOCAL_DATA_selected_outlet.delivery.max_radius_delivery) {
          this.$store.state.outside_radius = true
        } else {
          this.$store.state.outside_radius = false
          if (!this.$isEmpty(this.selected_outlet) && this.totalPriceItem < Number(this.selected_outlet.delivery.minimum_order)) {
            if (this.dataCheckoutDelivery.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
              this.dataCheckoutDelivery.shipping_cost = this.dataCheckoutDelivery.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius
            } else {
              this.dataCheckoutDelivery.shipping_cost = this.dataCheckoutDelivery.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius
            }
          } else {
            if (this.dataCheckoutDelivery.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
              this.dataCheckoutDelivery.shipping_cost = (this.dataCheckoutDelivery.shipping_radius - this.$store.state.selected_outlet.delivery.radius_free_delivery) * this.$store.state.selected_outlet.delivery.cost_outside_radius
            } else {
              this.dataCheckoutDelivery.shipping_cost = 0
            }
          }
          this.dataCheckoutDelivery.shipping_courier_id = null
          this.dataCheckoutDelivery.shipping_courier_name = ''
          this.$router.push({ name: 'delivery_time' }).catch(() => {})
        }
      }
      this.$store.dispatch('saveDataCartDelivery', this.dataCheckoutDelivery)
    },
    async getListShipping() {
      try {
        const params = {
          shipping_lat: this.dataCheckoutDelivery.shipping_lat,
          shipping_lon: this.dataCheckoutDelivery.shipping_lon,
          item: this.dataCheckoutDelivery.item
        }
        const { data } = await getDataShippingV2(params)
        this.$store.state.loading_axios = false
        this.list_shipping = data.data
      } catch (e) {
        // this.$store.state.show_error = true
        // this.$store.state.error_message = e.string
        // this.$store.state.error_type = e.statusCode
        return
      }
    }
  }
}
</script>
